import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/about-us-section-two-1.png";
import SectionTwoImageMobile from "../../Assets/Images/Credentials-1-Mob.png";
import AmericaFidImage from "../../Assets/Images/american-fidelity-white-logo.svg";
import AmericaFidRedImage from "../../Assets/Images/american-fidelity-red-logo.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const History = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div>
        <div className="my-12 -ml-4 md:ml-0 md:pl-4 lg:hidden flex justify-end md:justify-start overflow-hidden md:overflow-visible">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-[150%] md:w-auto md:max-w-[664px] max-w-none h-auto"
          />
        </div>
      </div>

      <div className="mt-2 max-w-[417px] reveal-up  px-4 history-tab-content-vs lg:hidden">
        <p className="text-[14px] text-left text-black extra-para-vs">
          {translations.historyDescription}
        </p>
      </div>
    </>
  );
};

export default History;
